<script>
	import { CheckSquareIcon } from 'svelte-feather-icons'

	export let handler
	export let color = ''
	export let disabled = false

	let promise
	let isWorking = false
	let isError = false
	let isSuccess = false


	function clickHandler() {
		if (!handler) return
		promise = handler()
		if (promise.then && promise.finally) {
			isWorking = true
			promise.then(() => {
				isSuccess = true
				setTimeout(() => {
					isSuccess = false
				}, 3000)
			}).catch(err => {
				console.error(err)
				isError = true
				setTimeout(() => {
					isError = false
				}, 3000)
			}).finally(() => {
				isWorking = false
			})
		}
	}
</script>

<div class="container" class:isError={isError} class:disabled={disabled}>
	<button on:click={clickHandler} {...$$props} class={color + ' ' + ($$props.class||"")} 
			disabled={isWorking||disabled} class:disabled={isWorking||disabled}>
		<slot />
	</button>
	{#if isWorking || isError}
		<div class="overlay"></div>
		<div class="spinner"></div>
	{/if}
	{#if isSuccess}
		<div class="success"><CheckSquareIcon /></div>
	{/if}
</div>

<style>
	.container {
		display: grid;
	}
	.container > * {
		grid-column: 1;
		grid-row: 1;
	}
	.container.isError {
		--color: red !important;
	}
	.overlay {
		background-color: rgb(255, 255, 255, 0.4);
	}

	.disabled {
		cursor:initial;
	}

	button {
		display: flex;
		align-items: center;
		margin: 0;
		user-select: none;
	}
	/* button:disabled {
		background-color: gray !important;
	} */

	button.green {
		--color: white;
		color: white;
		background-color: #0d754d;
	}
	button.green:hover { 
		background-color: #10915f;
	}

	button.orange {
		--color: white;
		color: white;
		background-color: orange;

	}
	button.orange:hover { 
		background-color: rgb(255, 186, 58);
	}

	button.red {
		--color: white;
		color: white;
		background-color: #a4311d;
	}
	button.red:hover {
		background-color: rgb(255, 75, 75);
	}

	.success {
		justify-self: end;
		color: green;
		align-self: center;
		margin-right: 8px;
		animation-name: fadeOut;
		animation-duration: 1s;
		animation-delay: 2s;
	}

	.spinner {
		margin: auto
	}
	.spinner:after {
		content: " ";
		display: block;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		border: 2px solid var(--color, black);
		border-color: var(--color, black) transparent var(--color, black) transparent;
		animation: lds-dual-ring 1.2s linear infinite;
	}
	@keyframes lds-dual-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes fadeOut {
		0% {opacity: 1;}
		100% {opacity: 0;} 
	}
	@media only screen and (max-width: 600px) {
		button.orange {
			padding: 6px;
		}
	}
</style>
